import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Dialog, type DrawerControlProps } from '@root/shared/ui-kit'

import { ReferralWithdraw } from './common/referral-withdraw'

type Props = DrawerControlProps

export const ReferralWithdrawDialog: React.FC<Props> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  const handleClose = () => onOpenChange?.(false)

  return (
    <Root
      variant="functional"
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('referral.withdraw.bring_out')}
    >
      <Dialog.Header.Functional>
        {t('referral.withdraw.bring_out')}
      </Dialog.Header.Functional>
      <Content $variant={0}>
        <ReferralWithdraw
          device="desktop"
          onClose={handleClose}
          css={css`
            padding-bottom: 20px;
          `}
        />
      </Content>
    </Root>
  )
}

const Root = styled(Dialog)`
  height: var(--max-drawer-height);
`

const Content = styled(Dialog.Content.Functional)`
  width: 420px;
  background: var(--background-2);
`
